import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Wrapper } from '@farewill/ui'
import ProductSummary from 'components/product-summary'
import { useSelector, shallowEqual } from 'react-redux'
import { InvoicesProvider, useInvoicesContext } from './context'

import ReferralEmailSummary from './referral-email-summary'
import RequestStatus from 'components/request-status'

const ProbateCaseQuote = () => {
  const { id: probateCaseId } = useParams()
  const { fetchInvoices, isUpdatingLineItem, updateLineItemErrors } =
    useInvoicesContext()
  const probateCase = useSelector((state) => state.probateCase)
  const referralEmailSent = !!probateCase.attributes.newLawReferral

  useEffect(() => {
    fetchInvoices({ queryParams: { 'filter[probateCaseId]': probateCaseId } })
  }, [fetchInvoices, probateCaseId])

  const { events, lead } = useSelector(
    (state) => ({
      events: state.productEvents,
      lead: state.lead.attributes && state.lead,
    }),
    shallowEqual
  )

  return (
    <Wrapper>
      {referralEmailSent && <ReferralEmailSummary />}
      <ProductSummary
        productType="probate"
        productEvents={events}
        lead={lead}
      />
      <RequestStatus
        isSaving={isUpdatingLineItem}
        apiErrors={updateLineItemErrors}
      />
    </Wrapper>
  )
}

const SaleWithProvider = ({ match }) => (
  <InvoicesProvider probateCaseId={match.params.id}>
    <ProbateCaseQuote />
  </InvoicesProvider>
)

export default SaleWithProvider
